// react
import { useNavigate } from "react-router-dom";
// form
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @polaris
import { Button, Box, Modal } from "@shopify/polaris";
// components
import { FormProvider } from "../../../components/hook-form";
import { RHFTextField, RHFPopoverSelect } from "../../../components/hook-form/v2";
import { Stack } from "../../../components";
// constants
import { APP_ROUTES, SETTINGS_TYPE } from "../../../common/constants";
// hooks
import useLocales from "../../../hooks/useLocales";
import useSettingsContext from "../../../hooks/useSettingsContext";

const NewSettingForm = ({ handleOnClose }) => {
  const { createSetting } = useSettingsContext();

  const navigate = useNavigate();
  const { translate } = useLocales();

  const SettingSchema = Yup.object().shape({
    name: Yup.string().max(200).required(translate("messages.settings.create-setting-template-required")),
  });

  const methods = useForm({
    resolver: yupResolver(SettingSchema),
    defaultValues: {
      name: "",
      type: SETTINGS_TYPE.PO,
    },
  });

  const onSubmit = async (data) => {
    handleOnClose();

    const id = await createSetting({ name: data.name, type: data.type });
    navigate(`${APP_ROUTES.SETTINGS.TEMPLATES}/${id}`);
  };

  const {
    watch,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Modal.Section>
        <Stack flexDirection="column" spacing={2}>
          <RHFTextField
            name="name"
            label={translate("page.setting.create-setting-template-label")}
            placeholder={translate("page.setting.create-setting-template-placeholder")}
          />
          <RHFPopoverSelect
            name="type"
            label={translate("page.setting.create-setting-template-type")}
            items={[
              {
                content: translate("common.pre-order"),
                value: SETTINGS_TYPE.PO,
              },
              {
                content: translate("common.back-in-stock"),
                value: SETTINGS_TYPE.BIS,
              },
              {
                content: translate("common.coming-soon"),
                value: SETTINGS_TYPE.CS,
              },
              {
                content: translate("common.in-stock-tab"),
                value: SETTINGS_TYPE.IS,
              },
            ]}
          />
        </Stack>
      </Modal.Section>

      <Box minHeight="61px" padding="400" display="flex">
        <Stack alignItems="center" justifyContent="flex-end" spacing={1}>
          <Button onClick={handleOnClose}>{translate("common.cancel")}</Button>

          <Button variant="primary" loading={isSubmitting} submit disabled={!values.name.length}>
            {translate("page.setting.create-setting-template")}
          </Button>
        </Stack>
      </Box>
    </FormProvider>
  );
};

export default NewSettingForm;
